import axios from "axios";
import { getToken } from "../Utlis/UpdateUsersState";

const getAllServers = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}servers/`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const createServer = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}servers/`,
      data,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const editServer = async (id, data) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}servers/?server_id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const deleteServer = async (server_id) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}servers/?server_id=${server_id}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

export { getAllServers, createServer, deleteServer, editServer };
